import classNames from 'classnames';
import React from 'react';
import EfImgVideo from '../ef-img-video';
import EfLink from '../ef-link';
import './index.scss';

interface EfCardSupportProps {
    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;

    /**
     * 主题色
     */
    theme?: 'white' | 'black';

    /**
     * 主标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;

    /**
     * 样式名
     */
    className?: string;

    /**
     * 更多详情-链接
     */
    moreLink?: string;
    /**
     * 更多详情-文案
     */
    moreText?: string;
    /**
     * 埋点--
     */
    dataLayer?: any[];
}

/**
 * 维护:谢保林
 *
 * 文案悬于图片左侧
 */
const EfCardSupport: React.FC<EfCardSupportProps> = ({
    isVideo,
    pc,
    h5,
    poster,
    posterH5,
    theme = 'black',
    title,
    desc,
    className,
    moreLink,
    moreText,
    dataLayer,
}) => {
    const prefixCls = `ef-card-support`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
    });
    const hasBtn = moreLink && moreText;

    // 埋点
    let btn_gtm = null;
    if (dataLayer) {
        btn_gtm = dataLayer;
    } else {
        btn_gtm = [
            {
                event: 'uaEvent',
                event_name: 'activity_preview',
                button_name: moreText,
            },
        ];
    }

    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`}>
                <div className={`${prefixCls}-msg`}>
                    {title && <h2 className={`${prefixCls}-title`}>{title}</h2>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                    {hasBtn && (
                        <div className={`${prefixCls}-btn-box`}>
                            {moreLink && moreText && (
                                <EfLink href={moreLink} className={`${prefixCls}-btn`} dataLayer={btn_gtm}>
                                    {moreText}
                                </EfLink>
                            )}
                        </div>
                    )}
                </div>
                <div className={`${prefixCls}-img`}>
                    <EfImgVideo isVideo={isVideo} pc={pc} h5={h5} poster={poster} posterH5={posterH5} autoPlay={true} loop={true} />
                </div>
            </div>
        </div>
    );
};

export default EfCardSupport;
